var _excluded = ["className"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { BedIcon, BathIcon, EnsuiteIcon, GarageIcon, CarportIcon, ParkingIcon } from '@domain-group/fe-co-icon';
import * as styles from './allhomes-listing-card-features.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesListingCardFeatures = _ref => {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'allhomes-listing-card__details-features' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  function renderFeatureIcon(value, Icon) {
    if (value) {
      return ___EmotionJSX("span", {
        className: "".concat(className, "-item")
      }, ___EmotionJSX("span", {
        className: "".concat(className, "-item-value")
      }, value), ___EmotionJSX("span", {
        css: styles.iconContainer
      }, ___EmotionJSX(Icon, {
        className: "".concat(className, "-item-icon")
      })));
    }
    return null;
  }
  return ___EmotionJSX("div", {
    className: className
  }, renderFeatureIcon(props.beds, BedIcon), renderFeatureIcon(props.baths, BathIcon), renderFeatureIcon(props.ensuite, EnsuiteIcon), renderFeatureIcon(props.garage, GarageIcon), renderFeatureIcon(props.carport, CarportIcon), renderFeatureIcon(props.parking, ParkingIcon));
};